var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { compact } from "lodash";
import React from "react";
import { Platform, TouchableOpacity } from "react-native";
import FormDropdownSelect from "../";
import { getFieldInfo, getFieldTitle } from "../../../../redux/form/form.utils";
import FormInputText from "../../FormInputText/FormInputText";
var FormDropdownSelectJsonFormSchema = /** @class */ (function (_super) {
    __extends(FormDropdownSelectJsonFormSchema, _super);
    function FormDropdownSelectJsonFormSchema() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Event handlers
        _this.handlePressExtraInfo = function () {
            var _a = _this.props, _b = _a.formContext, formContext = _b === void 0 ? {} : _b, uiSchema = _a.uiSchema;
            if (formContext.onPressExtraInfo) {
                formContext.onPressExtraInfo(uiSchema.extraInfoUrl);
            }
        };
        _this.handlePressSelectDropdown = function (_a) {
            var options = _a.options;
            return function () {
                var _a = _this.props, _b = _a.formContext, formContext = _b === void 0 ? {} : _b, name = _a.name, formData = _a.formData;
                if (formContext.onSelectMore) {
                    formContext.onSelectMore(name, formData, {
                        options: options,
                    });
                }
            };
        };
        return _this;
    }
    // Render
    FormDropdownSelectJsonFormSchema.prototype.render = function () {
        var _a = this.props, name = _a.name, schema = _a.schema, uiSchema = _a.uiSchema, _b = _a.rawErrors, rawErrors = _b === void 0 ? [] : _b, onChange = _a.onChange, formData = _a.formData, _c = _a.formContext, formContext = _c === void 0 ? {} : _c;
        var customUiSchema = uiSchema;
        // @ts-ignore
        var options = schema.options;
        var placeholder = customUiSchema.placeholder, isDisabled = customUiSchema.isDisabled;
        var disabled = isDisabled
            ? isDisabled(formContext.getAllFormData())
            : undefined;
        var handleSelect = function (newId) {
            var newIdParsed = newId === null ? undefined : newId;
            if (newIdParsed === placeholder) {
                newIdParsed = undefined;
            }
            onChange(newIdParsed);
            // TODO: Timeout?
            setTimeout(function () {
                if (formContext.onFieldChange) {
                    formContext.onFieldChange(name, newIdParsed);
                }
            }, 0);
        };
        var mappedOptions = compact(options.map(function (option) {
            var _a;
            var value = ((_a = option.getValue) === null || _a === void 0 ? void 0 : _a.call(option, formContext.getFormData())) || option.value;
            if (!value) {
                return undefined;
            }
            var result = {
                id: option.id,
                value: value,
            };
            return result;
        }));
        var title = getFieldTitle(customUiSchema, formContext);
        var isWeb = Platform.OS === "web";
        if (isWeb) {
            return (_jsx(FormDropdownSelect, __assign({}, customUiSchema, { onPressExtraInfo: this.handlePressExtraInfo, title: title, info: getFieldInfo(customUiSchema, formContext), selected: formData, options: mappedOptions, onSelect: handleSelect, placeholder: placeholder, error: rawErrors[0], disabled: disabled })));
        }
        var handleChangeValue = function (input) {
            var formattedInput = input.length === 0 ? undefined : input;
            onChange(formattedInput);
            // TODO: Timeout?
            setTimeout(function () {
                if (formContext.onFieldChange) {
                    formContext.onFieldChange(name, formattedInput);
                }
            }, 0);
        };
        var selectedItem = mappedOptions.find(function (_a) {
            var id = _a.id;
            return id === formData;
        });
        return (_jsx(TouchableOpacity, { onPress: this.handlePressSelectDropdown({ options: mappedOptions }), testID: title, children: _jsx(FormInputText, __assign({}, customUiSchema, { onPressExtraInfo: this.handlePressExtraInfo, title: title, info: getFieldInfo(customUiSchema, formContext), showDisclosureIcon: true, placeholder: placeholder, 
                // suffixText={suffixText}
                value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value, onChangeValue: handleChangeValue, error: rawErrors[0], disabled: disabled, textInputProps: {
                    editable: false,
                    pointerEvents: "none",
                } })) }));
    };
    return FormDropdownSelectJsonFormSchema;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default FormDropdownSelectJsonFormSchema;
